import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchSubCategoryMaster.css";
import CloseForm from "./CloseForm";
import axiosInstance from "../../api";
import Select from "react-select";

function SearchServiceReportMaster({
  setshowsearchform,
  setpagenumber,
  setReload,
  setSearch,
  reload,
}) {
  return (
    <div className="search-sub-category-master-form">
      <h3>Search Service Report Master</h3>

      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>

      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchServiceReportMaster;
